module.exports = __webpack_public_path__ + "img/edit.c0335985.svg";